import { ReqParams } from "../types";
import axiosInstance from "./axiosInstance";

// Tenant-side retention operations: view/override retention policies,
// browse archived records, and manage legal holds.
export default class RetentionService {

    // ---- Retention Policies ----
    static async getPolicies(params: ReqParams = {}) {
        const response = await axiosInstance.get("/tenant/retention/policies", { params });
        return response.data;
    }

    static async getPolicyDetails(id: string | number) {
        const response = await axiosInstance.get(`/tenant/retention/policies/${id}`);
        return response.data;
    }

    static async updatePolicy(id: string | number, data: any) {
        const response = await axiosInstance.put(`/tenant/retention/policies/${id}`, data);
        return response.data;
    }

    // ---- Archived Records ----
    static async getArchiveRecords(params: ReqParams = {}) {
        const response = await axiosInstance.get("/tenant/retention/archive-records", { params });
        return response.data;
    }

    static async getArchiveRecordDetails(id: string | number) {
        const response = await axiosInstance.get(`/tenant/retention/archive-records/${id}`);
        return response.data;
    }

    static async createDisposalApproval(data: any) {
        const response = await axiosInstance.post("/tenant/retention/disposal-approvals", data);
        return response.data;
    }

    // ---- Legal Holds ----
    static async getLegalHolds(params: ReqParams = {}) {
        const response = await axiosInstance.get("/tenant/retention/legal-holds", { params });
        return response.data;
    }

    static async createLegalHold(data: any) {
        const response = await axiosInstance.post("/tenant/retention/legal-holds", data);
        return response.data;
    }

    static async releaseLegalHold(id: string | number, data: any) {
        const response = await axiosInstance.put(`/tenant/retention/legal-holds/${id}/release`, data);
        return response.data;
    }

    // ---- Audit Trail ----
    static async getAuditTrail(params: ReqParams = {}) {
        const response = await axiosInstance.get("/tenant/retention/audit-trail", { params });
        return response.data;
    }
}
